import { getSession } from "@/lib/utils";
import { apiClient } from "@repo/lib/utils";

async function baseApiClient({
  path,
  options = {},
  headers = {},
  tags,
  cache = "force-cache",
  skipAuth,
}) {
  const session = await getSession();
  const tenantSlug = process.env.TENANT_SLUG || "alhome";
  return apiClient({
    path,
    options,
    headers,
    tags,
    cache,
    session,
    tenantSlug,
    skipAuth,
  });
}

export default baseApiClient;
